import React, { FC } from 'react';
import { Row, Col } from 'antd';
import styled from 'styled-components';
import { Typography } from './Typography';

const Header = styled.div`
  padding-top: 50px;
`;

interface PageHeaderProps {
  pageName?: string;
  headerColor?: string;
}

const PageHeader: FC<PageHeaderProps> = (props) => {
  const { pageName, headerColor } = props;
  return (
    <Header>
      <Row>
        <Col>
          <Typography
            variant="h6"
            as="h1"
            align="left"
            style={{ color: headerColor, marginBottom: '16px' }}
          >
            {pageName}
          </Typography>
        </Col>
        <Col flex="auto" />
      </Row>
    </Header>
  );
};

export default PageHeader;

PageHeader.defaultProps = {
  headerColor: undefined,
  pageName: ''
};
